import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import apiClient from "../services/api/axios";
import en from "./en";

const fetchTranslations = async (lang: string) => {
  try {
    const res = await apiClient.get(
      process.env.EXPO_PUBLIC_GET_UILM_FILE as string,
      {
        params: {
          projectKey: process.env.EXPO_PUBLIC_X_BLOCKS_KEY,
          moduleName: "selise-club",
          language: lang,
        },
      },
    );
    return res.data;
  } catch {
    return null;
  }
};

// fetch translations only if preferredLanguage is not en-US
const initI18n = async (preferredLanguage?: string) => {
  if (i18n.isInitialized) return;

  const lang = preferredLanguage ?? "en-US";
  const remote = lang === "en-US" ? null : await fetchTranslations(lang);

  await i18n.use(initReactI18next).init({
    resources: {
      [lang]: { translation: { ...en, ...remote } },
    },
    lng: lang,
    fallbackLng: "en-US",
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
  });
};

export const changeLanguage = async (lang: string) => {
  const remote = lang === "en-US" ? null : await fetchTranslations(lang);
  i18n.addResourceBundle(lang, "translation", { ...en, ...remote }, true, true);
  await i18n.changeLanguage(lang);
};

export { initI18n };
export default i18n;
